//To use this, put this in your HTML:
//  <date-range-picker #dateRangePicker></date-range-picker>
//Then put this in your TS file:
//  @ViewChild('dateRangePicker') dateRangePicker: DateRangePickerComponent;
//Then initialize it by calling the init() function. 
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ReportFavorite } from '../web-service/web.service';
import { ChromeDateFixer } from '../../shared/utilities/utilities';

@Component({
  selector: 'date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DateRangePickerComponent implements OnInit {
  gridFilter: ReportFavorite;
  callbackRefreshData: Function;

  constructor() {
  }

  ngOnInit() {
    ChromeDateFixer.initFixer();
  }

  //Call this to initalize the control.
  initDateRangePicker(gridFilter: ReportFavorite, callbackRefreshData: Function) {
    this.gridFilter = gridFilter;
    this.callbackRefreshData = callbackRefreshData;
  }

  //Converts one field to a number to be used in expressions in the HTML
  gridFilterPeriodNo(): number {
    return parseInt(this.gridFilter.periodNo);
  }

  refreshData() {
    if (this.callbackRefreshData)
      this.callbackRefreshData(true);
  }
}
